import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { CRMProvider } from './context/CRMContext';
import { UsersProvider, useUsers } from './context/UsersContext';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import LeadsList from './pages/LeadsList';
import LeadProfile from './pages/LeadProfile';
import CalendarView from './pages/CalendarView';
import UsersPage from './pages/UsersPage';
import LoginPage from './pages/LoginPage';
import '@questlabs/react-sdk/dist/style.css';

const AppShell = () => {
  const { currentUser, loginUser, logoutUser } = useUsers();

  const handleLogin = (email, password) => {
    const user = loginUser(email, password);
    return !!user;
  };

  if (!currentUser) {
    return <LoginPage onLogin={handleLogin} />;
  }

  return (
    <CRMProvider>
      <Router>
        <Layout onLogout={logoutUser}>
          <Routes>
            <Route path="/"          element={<Dashboard />} />
            <Route path="/leads"     element={<LeadsList />} />
            <Route path="/leads/:id" element={<LeadProfile />} />
            <Route path="/calendar"  element={<CalendarView />} />
            <Route path="/users"     element={<UsersPage />} />
            <Route path="*"          element={<Navigate to="/" replace />} />
          </Routes>
        </Layout>
      </Router>
    </CRMProvider>
  );
};

function App() {
  return (
    <UsersProvider>
      <AppShell />
    </UsersProvider>
  );
}

export default App;